import axiosInstance from "../lib/axiosInstance";


const Baseurl = process.env.REACT_APP_API_URL


const ratingModel = class {

    async Rate(data=[]) {
        return await axiosInstance.post(Baseurl +`/products/submit_rating`,data);
    }
    
}

export default new ratingModel();